import React, { createContext } from "react";
export const SizeContext = createContext({});
export const DEFAULT_HEIGHT = 80;
